export enum ValidationType {
  maxLength = 'max length',
  maxWordLength = 'max word length',
  required = 'required'
}
